import Vue from 'vue';
import Router from 'vue-router';
import * as authService from './components/services/auth.js' ;
import System from './components/pages/System.vue';
import * as auth from "./components/services/auth";

Vue.use(Router);
const routes = [
    {
        path: '/system',
        component: System,
        children: [
            {
                path: 'create-po',
                name: 'items',
                component: () => import(/* webpackChunkName: "items" */'./components/pages/Items.vue'),
            },
            {
                path: 'pending-po',
                name: 'approver',
                component: () => import(/* webpackChunkName: "approver" */'./components/pages/approver/Index.vue'),
            },
            {
                path: 'po_importation',
                name: 'po-importation',
                component: () => import(/* webpackChunkName: "po-importation" */'./components/pages/purchase-order/importation/list/index.vue'),
            },
            {
                path: 'po_importation_approval',
                name: 'po-importation-approval',
                component: () => import(/* webpackChunkName: "po-importation-approval" */'./components/pages/purchase-order/importation/approval/index.vue'),
            },
            {
                path: 'po_importation_approved',
                name: 'po-importation-approved',
                component: () => import(/* webpackChunkName: "po-importation-approved" */'./components/pages/purchase-order/importation/assign_pi/index.vue'),
            },
            {
                path: 'po_aging',
                name: 'po-aging',
                component: () => import(/* webpackChunkName: "po-aging" */'./components/pages/purchase-order/po_aging/index.vue'),
            },
            {
                path: 'po_incoming_items',
                name: 'po-incoming-items',
                component: () => import(/* webpackChunkName: "po-incoming-items" */'./components/pages/purchase-order/po_incoming_items_report/index.vue'),
            },
            {
                path: 'fc_po_report',
                name: 'fc-po-report',
                component: () => import(/* webpackChunkName: "po-incoming-items" */'./components/pages/purchase-order/fc_po_report/index.vue'),
            },
            {
                path: 'po_open_items',
                name: 'po-open-items',
                component: () => import(/* webpackChunkName: "po-open-items" */'./components/pages/purchase-order/po_open_items/index.vue'),
            },
            {
                path: 'po_open_items_logs',
                name: 'po-open-items-logs',
                component: () => import(/* webpackChunkName: "po-open-items-logs" */'./components/pages/purchase-order/po_open_items/po_open_items_logs.vue'),
            },
            {
                path: 'cancelled_pr_list',
                name: 'cancelled-pr-list',
                component: () => import(/* webpackChunkName: "cancelled-pr-list" */'./components/pages/purchase-request/cancelled_pr/index.vue'),
            },
            {
                path: 'pi_list',
                name: 'pi-list',
                component: () => import(/* webpackChunkName: "pi-list" */'./components/pages/purchase-order/importation/pi_list/index.vue'),
            },
            {
                path: 'pi_list/:id',
                name: "pi-details",
                component: () => import(/* webpackChunkName: "pi-details" */'./components/pages/purchase-order/importation/pi_list/Show'),
            },
            {
                path: 'pending-po/:id',
                name: "pending-po-details",
                component: () => import(/* webpackChunkName: "pending-po-details" */'./components/pages/approver/Show.vue'),
            },
            {
                path: 'po_importation/:id',
                name: "po-importation-details",
                component: () => import(/* webpackChunkName: "po-importation-details" */'./components/pages/purchase-order/importation/list/Show'),
            },
            {
                path: 'po_importation_approval/:id',
                name: "po-importation-approval-details",
                component: () => import(/* webpackChunkName: "po-importation-approval-details" */'./components/pages/purchase-order/importation/approval/Show'),
            },
            {
                path: 'my-purchase-orders',
                name: 'requests',
                component: () => import(/* webpackChunkName: "requests" */'./components/pages/requests/Index.vue'),
            },
            {
                path: 'my-purchase-orders/:id',
                name: 'request-details',
                component: () => import(/* webpackChunkName: "request-details" */'./components/pages/requests/Show.vue'),
            },
            {
                path: 'permission',
                name: 'permission',
                component: () => import(/* webpackChunkName: "permission" */ './components/pages/Permission.vue'),
            },
            {
                path: 'assign_rel_code',
                name: 'assign_rel_code',
                component: () => import(/* webpackChunkName: "assign-rel-code" */'./components/pages/AssignRelCode'),
            },
            {
                path: 'approval_maintenance',
                name: 'approval_maintenance',
                component: () => import(/* webpackChunkName: "approval-maintenance" */'./components/pages/ApprovalMaintenance.vue'),
            },
            {
                path: 'role',
                name: 'role',
                component: () => import(/* webpackChunkName: "role" */'./components/pages/Role.vue')
            },
            {
                path: 'user',
                name: 'user',
                component: () => import(/* webpackChunkName: "user" */'./components/pages/User.vue')
            },
            {
                path: 'notifications',
                name: 'notifications',
                component: () => import(/* webpackChunkName: "notifications" */'./components/pages/EmailNotifications.vue')
            },
            {
                path: 'user-supplier',
                name: 'user-supplier',
                component: () => import(/* webpackChunkName: "user-supplier" */'./components/pages/user_supplier/index')
            },
            {
                path: 'user-approver',
                name: 'user-approver',
                component: () => import(/* webpackChunkName: "user-approver" */'./components/pages/user_approver/index')
            },
            {
                path: 'supplier-recommendation',
                name: 'supplier-recommendation',
                component: () => import(/* webpackChunkName: "supplier-recommendation" */'./components/pages/pr_st_creation/supplier_recommendation.vue')
            },
            {
                path: 'activities',
                name: 'activities',
                component: () => import(/* webpackChunkName: "activities" */'./components/pages/Activities.vue')
            },
            {
                path: 'user-activities',
                name: 'user-activities',
                component: () => import(/* webpackChunkName: "user-activities" */'./components/pages/profile/Activity.vue')
            },
            {
                path: 'profile',
                name: 'profile',
                component: () => import(/* webpackChunkName: "profile" */'./components/pages/profile/Index.vue')
            },
            {
                path: 'po-history',
                name: 'po-history',
                component: () => import(/* webpackChunkName: "po-history" */'./components/pages/purchase-order/history/Index.vue')
            },
            {
                path: 'po-history/:id',
                name: 'po-details',
                component: () => import(/* webpackChunkName: "po-details" */ './components/pages/purchase-order/history/Show.vue')
            },
            {
                path: 'po-type',
                name: 'po-type',
                component: () => import(/* webpackChunkName: "po-type" */'./components/pages/purchase-order/type/Index.vue')
            },
            {
                path: 'pr-history',
                name: 'pr-history',
                component: () => import(/* webpackChunkName: "pr-history" */'./components/pages/purchase-request/history/Show.vue')
            },
            {
                path: 'pr-history/:id',
                name: 'pr-details',
                component: () => import(/* webpackChunkName: "pr-details" */'./components/pages/purchase-request/history/Show.vue')
            },
            {
                path: 'my-purchase-requests',
                name: 'pr-request',
                component: () => import(/* webpackChunkName: "pr-request" */'./components/pages/purchase-request/requests/Index.vue')
            },
            {
                path: 'my-purchase-requests/:id',
                name: 'pr-request-details',
                component: () => import(/* webpackChunkName: "pr-request-details" */'./components/pages/purchase-request/requests/Show.vue')
            },
            {
                path: 'pending-pr',
                name: 'pending-pr',
                component: () => import(/* webpackChunkName: "pending-pr" */'./components/pages/purchase-request/approver/Index.vue')
            },
            {
                path: 'pending-pr/:id',
                name: 'pending-pr-details',
                component: () => import(/* webpackChunkName: "pending-pr-details" */'./components/pages/purchase-request/approver/Show.vue')
            },
            {
                path: 'pr_cwh_list',
                name: 'pr-cwh-list',
                component: () => import(/* webpackChunkName: "pr-cwh-list" */'./components/pages/purchase-request/pr_central_warehouse/index.vue'),
            },
            {
                path: 'create-pr',
                name: 'create-pr',
                component: () => import(/* webpackChunkName: "create-pr" */'./components/pages/purchase-request/Index.vue')
            },
            {
                path: 'manual-create-pr',
                name: 'manual-create-pr',
                component: () => import(/* webpackChunkName: "manual-create-pr" */'./components/pages/purchase-request/Create.vue'),
            },
            {
                path: 'inventory',
                name: 'inventory',
                component: () => import(/* webpackChunkName: "inventory" */'./components/pages/inventory-management/Index.vue')
            },
            {
                path: 'inventory_pvc',
                name: 'inventory_pvc',
                component: () => import(/* webpackChunkName: "inventory_pvc" */'./components/pages/inventory-management-pvc/Index.vue')
            },
            {
                path: 'pr-drafts',
                name: 'pr-drafts',
                component: () => import(/* webpackChunkName: "pr-drafts" */'./components/pages/purchase-request/drafts/Index.vue')
            },
            {
                path: 'pr-drafts/:id',
                name: 'pr-draft-details',
                component: () => import(/* webpackChunkName: "pr-draft-details" */'./components/pages/purchase-request/drafts/Show.vue')
            },
            {
                path:'inventory-package',
                name:'inventory-package',
                component:()=>import(/* webpackChunkName: "inventory-package" */'./components/pages/inventory-management/Compenents.vue')
            },
            // LEMUEL TARRAZONA (06/22/2021)
            {
                path:'material-history',
                name:'material-history',
                component:( )=>import( /* webpackChunkName: "material-history" */'./components/pages/history/materials/Index.vue' ),
                redirect:{ name:'material-history-table' },
                children:[
                    {
                        path:'',
                        name:'material-history-table',
                        component:( )=>import( /* webpackChunkName: "material-history-table" */'./components/pages/history/materials/_Table.vue' )
                    }
                ]
            },
            {
                path:'material-offtake',
                name:'material-offtake',
                component:( )=>import( /* webpackChunkName: "material-offtake" */'./components/pages/history/materialofftakes/Index.vue' ),
                redirect:{ name: 'material-offtake-table' },
                children:[
                    {
                        path:'',
                        name:'material-offtake-table',
                        component:( )=>import( /* webpackChunkName: "material-offtake-table" */'./components/pages/history/materialofftakes/_Table.vue' )
                    }
                ]
            },
            {
                path: 'offtake_report',
                name: 'offtake-report',
                component: () => import(/* webpackChunkName: "offtake-report" */'./components/pages/history/offtake-report/index'),
            },
            {
                path:'release-po',
                name:'release-po',
                component:( )=>import( /* webpackChunkName: "release-po" */'./components/pages/purchase-order/release-po/index/Index.vue' ),
                redirect:{name:'release-po-table'},
                children:[
                    {
                        path:'',
                        name:'release-po-table',
                        component:()=>import(/* webpackChunkName: "release-po-table" */'./components/pages/purchase-order/release-po/index/_Table.vue')
                    }
                ]
            },
            {
                path:'release-po/:id',
                name:'release-po-details',
                component:()=>import(/* webpackChunkName: "release-po-details" */'./components/pages/purchase-order/release-po/show/Index.vue'),
                redirect:{name:'release-po-details-table'},
                children:[
                    {
                        path:'',
                        name:'release-po-details-table',
                        component:()=>import(/* webpackChunkName: "release-po-details-table" */'./components/pages/purchase-order/release-po/show/_Table.vue')
                    }
                ]
            },
            {
                path:'material-master',
                name:'material-master',
                component:()=>import(/* webpackChunkName: "material-master" */'./components/pages/material-management/material-master/index/Index.vue'),
                redirect:{name:'material-master-table'},
                children:[
                    {
                        path:'',
                        name:'material-master-table',
                        component:()=>import(/* webpackChunkName: "material-master-table" */'./components/pages/material-management/material-master/index/_Table.vue')
                    }
                ]
            },
            {
                path:'for-release-purchase-returns',
                name:'for-release-purchase-returns',
                component:()=>import(/* webpackChunkName: "for-release-purchase-returns" */'./components/pages/purchase-returns/release/Index.vue'),
                redirect:{name:'for-release-purchase-returns-table'},
                children:[
                    {
                        path:'',
                        name:'for-release-purchase-returns-table',
                        component:()=>import(/* webpackChunkName: "for-release-purchase-returns-table" */'./components/pages/purchase-returns/release/_Table.vue')
                    }
                ]
            },
            {
                path:'purchase-returns',
                name:'purchase-returns',
                component:()=>import(/* webpackChunkName: "purchase-returns" */'./components/pages/purchase-returns/index/Index.vue'),
                redirect:{name:'purchase-returns-table'},
                children:[
                    {
                        path:'',
                        name:'purchase-returns-table',
                        component:()=>import(/* webpackChunkName: "purchase-returns-table" */'./components/pages/purchase-returns/index/_Table.vue')
                    }
                ]
            },
            {
                path:'purchase-return/:id',
                name:'purchase-return-details',
                component:()=>import(/* webpackChunkName: "purchase-return-details" */'./components/pages/purchase-returns/show/Index.vue'),
                redirect:{name:'purchase-return-table'},
                children:[
                    {
                        path:'',
                        name:'purchase-return-table',
                        component:()=>import(/* webpackChunkName: "purchase-return-table" */'./components/pages/purchase-returns/show/_Table.vue')
                    }
                ]
            },
            {
                path:'purchase-return-create',
                name:'purchase-return-create',
                component:()=>import(/* webpackChunkName: "purchase-return-create" */'./components/pages/purchase-returns/create/Index.vue'),
                redirect:{name:'purchase-return-create-table'},
                children:[
                    {
                        path:'',
                        name:'purchase-return-create-table',
                        component:()=>import(/* webpackChunkName: "purchase-return-create-table" */'./components/pages/purchase-returns/create/_Table.vue')
                    }
                ]
            },
            {
                path:'my-purchase-returns',
                name:'my-purchase-returns',
                component:()=>import(/* webpackChunkName: "my-purchase-returns" */'./components/pages/purchase-returns/my-purchase-returns/index/Index.vue'),
                redirect:{name:'my-purchase-returns-table'},
                children:[
                    {
                        path:'',
                        name:'my-purchase-return-table',
                        component:()=>import(/* webpackChunkName: "my-purchase-return-table" */'./components/pages/purchase-returns/my-purchase-returns/index/_Table.vue')
                    }
                ]
            },
            {
                path:'my-purchase-returns/:id',
                name:'my-purchase-return-details',
                component:()=>import(/* webpackChunkName: "my-purchase-return-details" */'./components/pages/purchase-returns/my-purchase-returns/show/Index.vue'),
                redirect:{name:'my-purchase-return-details-table'},
                children:[
                    {
                        path:'',
                        name:'my-purchase-return-details-table',
                        component:()=>import(/* webpackChunkName: "my-purchase-return-details-table" */'./components/pages/purchase-returns/my-purchase-returns/show/_Table.vue')
                    }
                ]
            },
            {
                path:'purchase-return-draft',
                name:'purchase-return-draft',
                component:()=>import(/* webpackChunkName: "purchase-return-draft" */'./components/pages/purchase-returns/draft/index/Index.vue'),
                redirect:{name:'purchase-return-draft-table'},
                children:[
                    {
                        path:'',
                        name:'purchase-return-draft-table',
                        component:()=>import(/* webpackChunkName: "purchase-return-draft-table" */'./components/pages/purchase-returns/draft/index/_Table.vue')
                    }
                ]
            },
            {
                path:'purchase-return-draft/:id',
                name:'purchase-return-draft-details',
                component:()=>import(/* webpackChunkName: "purchase-return-draft-details" */'./components/pages/purchase-returns/draft/show/Index.vue'),
                redirect:{name:'purchase-return-draft-details-table'},
                children:[
                    {
                        path:'',
                        name:'purchase-return-draft-details-table',
                        component:()=>import(/* webpackChunkName: "purchase-return-draft-details-table" */'./components/pages/purchase-returns/draft/show/_Table.vue')
                    }
                ]
            },
            // LEMUEL END
            // LEMUEL START 11/04/2021
            {
                path:'approved-purchase-returns',
                name:'approved-purchase-returns',
                component:()=>import(/* webpackChunkName: "approved-purchase-returns" */'./components/pages/purchase-returns/approved/index/Index.vue'),
                redirect:{name:'approved-purchase-return-table'},
                children:[
                    {
                        path:'',
                        name:'approved-purchase-return-table',
                        component:()=>import(/* webpackChunkName: "approved-purchase-return-table" */'./components/pages/purchase-returns/approved/index/_Table.vue')
                    }
                ]
            },
            // LEMUEL END
            {
                path: 'stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */'./components/pages/stock-transfer/stock-transfer'),
                children: [
                    {
                        path: 'create',
                        name: 'create-stock-transfer',
                        component: () => import(/* webpackChunkName: "create-stock-transfer" */'./components/pages/stock-transfer/Create')
                    },
                    {
                        path: 'view_packing_list',
                        name: 'view_packing_list-stock-transfer',
                        component: () => import(/* webpackChunkName: "view_packing_list-stock-transfer" */'./components/pages/stock-transfer/ViewPackingList')
                    },
                    {
                        path: 'view_packing_list_draft',
                        name: 'view_packing_list-stock-transfer-draft',
                        component: () => import(/* webpackChunkName: "view_packing_list-stock-transfer-draft" */'./components/pages/stock-transfer/PackingListDraft.vue')
                    },

                    {
                        path: 'view_packing_list/:id',
                        name: 'show-packing_list-stock-transfer',
                        component: () => import(/* webpackChunkName: "view_packing_list_detail-stock-transfer" */'./components/pages/stock-transfer/ShowPackingList')
                    },

                    {
                        path: 'view_packing_list_draft/:id',
                        name: 'show-packing_list-stock-transfer-draft',
                        component: () => import(/* webpackChunkName: "view_packing_list_detail-stock-transfer-draft" */'./components/pages/stock-transfer/PackingListShowDraft.vue')
                    },

                    {
                        path: 'on_order',
                        name: 'on_order-stock-transfer',
                        component: () => import(/* webpackChunkName: "list-stock-transfer" */'./components/pages/stock-transfer/List')
                    },

                    {
                        path: 'on_order_open_only',
                        name: 'on_order_open_only-stock-transfer',
                        component: () => import(/* webpackChunkName: "list-open-only-stock-transfer" */'./components/pages/stock-transfer/ListOpenOnly')
                    },

                    {
                        path: 'on_order/:id',
                        name: 'show-on_order-stock-transfer',
                        component: () => import(/* webpackChunkName: "show-stock-transfer" */'./components/pages/stock-transfer/Show.vue')
                    },
                    {
                        path: 'for_serving',
                        name: 'for_serving-stock-transfer',
                        component: () => import(/* webpackChunkName: "list-for_serving-stock-transfer" */'./components/pages/stock-transfer/ForServingList')
                    },
                    {
                        path: 'for_serving_open_only',
                        name: 'for_serving_open_only-stock-transfer',
                        component: () => import(/* webpackChunkName: "list-for_serving_open-only-stock-transfer" */'./components/pages/stock-transfer/ForServingListOpenOnly')
                    },
                    {
                        path: 'for_serving/:id',
                        name: 'show-for_serving-stock-transfer',
                        component: () => import(/* webpackChunkName: "show-for_serving-stock-transfer" */'./components/pages/stock-transfer/Show.vue')
                    },



                    {
                        path: 'store_loc_req',
                        name: 'store_loc_req-stock-transfer',
                        component: () => import(/* webpackChunkName: "list-stock-transfer" */'./components/pages/stock-transfer/StoreLocReqList')
                    },
                    {
                        path: 'store_loc_req/:id',
                        name: 'show-store_loc_req-stock-transfer',
                        component: () => import(/* webpackChunkName: "show-stock-transfer" */'./components/pages/stock-transfer/Show.vue')
                    },

                    {
                        path: 'pending_list',
                        name: 'pending_list-stock-transfer',
                        component: () => import(/* webpackChunkName: "pending_list-stock-transfer" */'./components/pages/stock-transfer/PendingList.vue')
                    },
                    {
                        path: 'pending_list/:id',
                        name: 'approve-stock-transfer',
                        component: () => import(/* webpackChunkName: "approve-stock-transfer" */'./components/pages/stock-transfer/Approval.vue')
                    },
                    {
                        path: 'approved_requests',
                        name: 'approved_requests-stock-transfer',
                        component: () => import(/* webpackChunkName: "approved_requests-stock-transfer" */'./components/pages/stock-transfer/ApprovedRequests')
                    },
                    {
                        path: 'approved_requests_by_material',
                        name: 'approved_requests_by_material-stock-transfer',
                        component: () => import(/* webpackChunkName: "approved_requests-stock-transfer" */'./components/pages/stock-transfer/approved_requests/by_material')
                    },
                    {
                        path: 'approved_requests/:id',
                        name: 'show-approved_request-stock-transfer',
                        component: () => import(/* webpackChunkName: "show-approved_request-stock-transfer" */'./components/pages/stock-transfer/_formShow')
                    },

                    {
                        path: 'transaction_history',
                        name: 'history-stock-transfer',
                        component: () => import(/* webpackChunkName: "history-stock-transfer" */'./components/pages/stock-transfer/History')
                    },
                    {
                        path: 'request_history',
                        name: 'request_history-stock-transfer',
                        component: () => import(/* webpackChunkName: "request_history-stock-transfer" */'./components/pages/stock-transfer/RequestHistory')
                    },
                    {
                        path: 'receiving',
                        name: 'receive-stock-transfer',
                        component: () => import(/* webpackChunkName: "receive-stock-transfer" */'./components/pages/stock-transfer/Receive')
                    },
                    {
                        path: 'receiving/:id',
                        name: 'show-receive-stock-transfer',
                        component: () => import(/* webpackChunkName: "show-receive-stock-transfer" */'./components/pages/stock-transfer/_formShowReceive')
                    },

                    {
                        path: 'for_confirmation',
                        name: 'for_confirmation-stock-transfer',
                        component: () => import(/* webpackChunkName: "confirm-stock-transfer" */'./components/pages/stock-transfer/Confirm')
                    },

                    {
                        path: 'packing_list',
                        name: 'packing_list-stock-transfer',
                        component: () => import(/* webpackChunkName: "packing_list-stock-transfer" */'./components/pages/stock-transfer/PackingList')
                    },

                    {
                        path: 'damage_report',
                        name: 'damage_report-stock-transfer',
                        component: () => import(/* webpackChunkName: "damage_report-stock-transfer" */'./components/pages/stock-transfer/DamageReport')
                    },

                    {
                        path: 'unprocessed_stor_loc_trans',
                        name: 'unprocessed_stor_loc_trans-stock-transfer',
                        component: () => import(/* webpackChunkName: "unprocessed_damage_report-stock-transfer" */'./components/pages/stock-transfer/UnprocessedStoreLocTransfer')
                    },

                    {
                        path: 'for_approval_stor_loc_trans',
                        name: 'for_approval_stor_loc_trans-stock-transfer',
                        component: () => import(/* webpackChunkName: "for_approval_damage_report-stock-transfer" */'./components/pages/stock-transfer/StoreLocTransferForApproval')
                    },

                    {
                        path: 'for_approval_stor_loc_trans/:id',
                        name: 'show_for_approval_stor_loc_trans-stock-transfer',
                        component: () => import(/* webpackChunkName: "show_for_approval_stor_loc_trans-stock-transfer" */'./components/pages/stock-transfer/StoreLocTransferForApprovalDetails.vue')
                    },

                    {
                        path: 'unprocessed_stor_loc_trans/:id',
                        name: 'show_unprocessed_stor_loc_trans-stock-transfer',
                        component: () => import(/* webpackChunkName: "show_unprocessed_damage_report-stock-transfer" */'./components/pages/stock-transfer/ShowUnprocessed.vue')
                    },
                    {
                        path: 'transfer_out',
                        name: 'transfer_out-stock-transfer',
                        component: () => import(/* webpackChunkName: "transfer_out-stock-transfer" */'./components/pages/stock-transfer/TransferOut')
                    },
                    {
                        path: 'unprocessed_transfer_out',
                        name: 'unprocessed_transfer_out-stock-transfer',
                        component: () => import(/* webpackChunkName: "unprocessed_transfer_out-stock-transfer" */'./components/pages/stock-transfer/UnprocessedTransferOut')
                    },

                    {
                        path: 'unprocessed_transfer_out/:id',
                        name: 'show_unprocessed_transfer_out-stock-transfer',
                        component: () => import(/* webpackChunkName: "show_unprocessed_transfer_out-stock-transfer" */'./components/pages/stock-transfer/ShowUnprocessedTransferOut.vue')
                    },

                    {
                        path: 'for_confirmation/:id',
                        name: 'show-confirm-stock-transfer',
                        component: () => import(/* webpackChunkName: "show-confirm-stock-transfer" */'./components/pages/stock-transfer/_formShowConfirm')
                    },

                    {
                        path: 'reserved_material_list',
                        name: 'reserved-stock-transfer',
                        component: () => import(/* webpackChunkName: "reserved-stock-transfer" */'./components/pages/stock-transfer/ReservedMaterials')
                    },
                ]
            },

            {
                path: 'goods-receipt',
                component: () => import(/* webpackChunkName: "goods-receipt" */'./components/pages/goods-receipt-management/index'),
                children: [
                    {
                        path: 'list',
                        name: 'goods-receipt-list',
                        component: () => import(/* webpackChunkName: "list-goods-receipt" */'./components/pages/goods-receipt-management/list_of_PO/list')
                    },
                    {
                        path: 'list/:id',
                        name: 'goods-receipt-show',
                        component: () => import(/* webpackChunkName: "show-goods-receipt" */'./components/pages/goods-receipt-management/list_of_PO/show')
                    },
                    {
                        path: 'receive-order/:id',
                        name: 'goods-receipt-receive',
                        component: () => import(/* webpackChunkName: "receive-goods-receipt" */'./components/pages/goods-receipt-management/list_of_PO/receive')
                    },

                    {
                        path: 'receiving-report',
                        name: 'goods-receipt-receiving-report',
                        component: () => import(/* webpackChunkName: "receiving-report-goods-receipt" */'./components/pages/goods-receipt-management/receiving_report/list'),
                        props: { search: null }
                    },

                    {
                        path: 'receiving-report/:id',
                        name: 'goods-receipt-receiving-report-show',
                        component: () => import(/* webpackChunkName: "receiving-report-goods-receipt-show" */'./components/pages/goods-receipt-management/receiving_report/show')
                    },

                    {
                        path: 'assign-dr',
                        name: 'assign-dr-create',
                        component: () => import(/* webpackChunkName: "assign_dr" */'./components/pages/goods-receipt-management/assign_dr/Create.vue')
                    },
                    {
                        path: 'list-dr',
                        name: 'dr-list',
                        component: () => import(/* webpackChunkName: "assign_dr" */'./components/pages/goods-receipt-management/assign_dr/list.vue')
                    },
                    {
                        path: 'list-dr/:id',
                        name: 'dr-show',
                        component: () => import(/* webpackChunkName: "assign_dr" */'./components/pages/goods-receipt-management/assign_dr/show.vue')
                    },


                ]
            },
            {
                path: 'inventory_monitoring',
                component: () => import(/* webpackChunkName: "inventory-monitoring" */'./components/pages/inventory-monitoring/index'),
                children: [
                    {
                        path: 'list',
                        name: 'inventory_monitoring_list',
                        component: () => import(/* webpackChunkName: "list-inventory_monitoring" */'./components/pages/inventory-monitoring/list')
                    },
                    // {
                    //     path: 'list/:id',
                    //     name: 'goods-receipt-show',
                    //     component: () => import(/* webpackChunkName: "show-goods-receipt" */'./components/pages/goods-receipt-management/list_of_PO/show')
                    // },
                    // {
                    //     path: 'receive-order/:id',
                    //     name: 'goods-receipt-receive',
                    //     component: () => import(/* webpackChunkName: "receive-goods-receipt" */'./components/pages/goods-receipt-management/list_of_PO/receive')
                    // },
                    //
                    // {
                    //     path: 'receiving-report',
                    //     name: 'goods-receipt-receiving-report',
                    //     component: () => import(/* webpackChunkName: "receiving-report-goods-receipt" */'./components/pages/goods-receipt-management/receiving_report/list'),
                    //     props: { search: null }
                    // },
                    //
                    // {
                    //     path: 'receiving-report/:id',
                    //     name: 'goods-receipt-receiving-report-show',
                    //     component: () => import(/* webpackChunkName: "receiving-report-goods-receipt-show" */'./components/pages/goods-receipt-management/receiving_report/show')
                    // },


                ]
            },
            {
                path: 'goods-issue',
                component: () => import(/* webpackChunkName: "goods-issue" */'./components/pages/goods-issue-management/index'),
                children: [
                    {
                        path: 'list',
                        name: 'goods-issue-list',
                        component: () => import(/* webpackChunkName: "list-goods-issue" */'./components/pages/goods-issue-management/list')
                    },
                    {
                        path: 'list/:id',
                        name: 'goods-issue-show',
                        component: () => import(/* webpackChunkName: "show-goods-issue" */'./components/pages/goods-issue-management/show')
                    },
                    {
                        path: 'create',
                        name: 'create-goods-issue',
                        component: () => import(/* webpackChunkName: "create-goods-issue" */'./components/pages/goods-issue-management/Create')
                    },



                ]
            },

            {
                path: 'trucking-report',
                component: () => import(/* webpackChunkName: "trucking-report" */'./components/pages/trucking_report/index'),
                children: [
                    {
                        path: 'list',
                        name: 'trucking-report-list',
                        component: () => import(/* webpackChunkName: "list-trucking-report" */'./components/pages/trucking_report/list')
                    },
                    {
                        path: 'list/:id',
                        name: 'trucking-report-list-show',
                        component: () => import(/* webpackChunkName: "show-trucking-report" */'./components/pages/trucking_report/show')
                    },
                    {
                        path: 'create',
                        name: 'create-trucking-report',
                        component: () => import(/* webpackChunkName: "create-trucking-report" */'./components/pages/trucking_report/Create')
                    },
                    {
                        path: 'maintenance',
                        name: 'truck-maintenance',
                        component: () => import(/* webpackChunkName: "truck-maintenance" */'./components/pages/trucking_report/trucking_maintenance.vue')
                    },



                ]
            },
            {
                path: 'po-config',
                name: 'po-config',
                component: () => import(/* webpackChunkName: "po-config-index" */'./components/pages/po-config/index')
            },
            {
                path: 'pr-st-create',
                name: 'pr-st-create',
                component: () => import(/* webpackChunkName: "pr-st-create" */'./components/pages/pr_st_creation/create')
            },
            {
                path: 'pr-st-drafts',
                name: 'pr-st-drafts',
                component: () => import(/* webpackChunkName: "pr-st-list" */'./components/pages/pr_st_creation/list')
            },
            {
                path: 'pr-st-drafts/:id',
                name: 'pr-st-drafts-show',
                component: () => import(/* webpackChunkName: "pr-st-show" */'./components/pages/pr_st_creation/show')
            },
            {
                path: 'change-logs',
                name: 'change-logs',
                component: () => import(/* webpackChunkName: "change-logs-index" */'./components/pages/change-logs/index')
            },

            {
                path: 'stockcard-list',
                name: 'stockcard-list',
                component: () => import(/* webpackChunkName: "stockcard-list" */'./components/pages/stock_card/stock_card')
            },
            {
                path: 'stockcard-begbal',
                name: 'stockcard-begbal',
                component: () => import(/* webpackChunkName: "stockcard-begbal" */'./components/pages/stock_card/beg_bal')
            },
            {
                path: 'stockcard-list/:plant/:lgort/:matnr/:year',
                name: 'stockcard-details',
                component: () => import(/* webpackChunkName: "stockcard-details" */'./components/pages/stock_card/details')
            },
            {
                path: 'inventory-ordering',
                name: 'inventory-ordering',
                component: () => import(/* webpackChunkName: "inventory-ordering" */'./components/pages/inventory-ordering/index')
            },
            {
                path: 'inventory-ordering-purchasing',
                name: 'inventory-ordering-purchasing',
                component: () => import(/* webpackChunkName: "inventory-ordering-create" */'./components/pages/inventory-ordering/create')
            },
            {
                path: 'inventory-ordering-logistics',
                name: 'inventory-ordering-logistics',
                component: () => import(/* webpackChunkName: "inventory-ordering-create" */'./components/pages/inventory-ordering/port_entry')
            },
            {
                path: 'inventory-ordering-inventory',
                name: 'inventory-ordering-inventory',
                component: () => import(/* webpackChunkName: "inventory-ordering-inventory" */'./components/pages/inventory-ordering/inventory_entry')
            },
            {
                path: 'inventory-ordering/history',
                name: 'inventory-ordering-history',
                component: () => import(/* webpackChunkName: "inventory-ordering-history" */'./components/pages/inventory-ordering/history')
            },


        ],
        meta: {transition: 'zoom'},
        beforeEnter(to, from, next) {
            if (!authService.authenticated()) {
                console.log('redirect');
                next('/');
            } else {
                console.log('proceed');
                next();
            }
        }
    },
    {
        path: '/',
        name: 'login',
        component: () => import('./components/pages/Login.vue'),
        // beforeEnter(to, from, next) {
        //     if (!authService.authenticated()) {
        //         next();
        //     } else {
        //         next('/system');
        //     }
        // }

    },
]

const router = new Router({
    mode: 'history',
    routes: routes,
    linkActiveClass: 'active'
});

export default router;